import { render, staticRenderFns } from "./snsCreate.vue?vue&type=template&id=2420a375&"
import script from "./snsCreate.vue?vue&type=script&lang=js&"
export * from "./snsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports